import "./scss/index.scss";
import classNames from "classnames";
import { RichText } from "prismic-reactjs";
import React from "react";
import { ContactsNav } from "../ContactsNav";
export function TopBar(_ref) {
  var message = _ref.message,
      contact = _ref.contact,
      isScrolled = _ref.isScrolled;
  return React.createElement("div", {
    className: classNames("top-bar container-flex", {
      "top-bar--hidden": isScrolled
    })
  }, React.createElement("div", {
    className: "row"
  }, React.createElement("div", {
    className: "top-bar__copyright"
  }, message && React.createElement(RichText, {
    render: message
  })), React.createElement(ContactsNav, {
    contact: contact
  })));
}